const ACCESS_KEY = "accessToken";

export function setAccessToken(token) {
  try {
    if (token) {
      localStorage.setItem(ACCESS_KEY, token);
    } else {
      localStorage.removeItem(ACCESS_KEY);
    }
  } catch {
    /* ignore */
  }
}

export function getAccessToken() {
  try {
    return localStorage.getItem(ACCESS_KEY) || null;
  } catch {
    return null;
  }
}

export function clearAccessToken() {
  try {
    localStorage.removeItem(ACCESS_KEY);
  } catch {
    /* ignore */
  }
}

export function getAccessTokenExpiresAtMs(token = getAccessToken()) {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;
  let b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
  while (b64.length % 4) b64 += "=";
  try {
    const payload = JSON.parse(atob(b64));
    return typeof payload.exp === "number" ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}
